import { IconButton } from '@mui/material';
import type { UsageProductInput } from '@vy/types';
import { withDefault } from '@vy/utils';
import { useFormContext } from 'react-hook-form';
import { CloseIcon } from '../../../../../../components/icons';
import type { NewPlanForm } from '../../CreatePlanForm/create-plan-form-types/new-plan-form';
import type { PlanInputForm } from '../../CreatePlanForm/create-plan-form-types/plan-input-form';

type RemoveMeteredCreditRowProps = {
  meteredCredit: UsageProductInput;
};

export const RemoveMeteredCreditRow: React.FC<RemoveMeteredCreditRowProps> = ({ meteredCredit }) => {
  const { setValue, getValues } = useFormContext<PlanInputForm, NewPlanForm>();

  const handleRemoveRow = () => {
    const usageProducts = getValues('usageProducts');
    const updatedUsageProducts = withDefault(usageProducts, []).filter(
      (usageProduct) => usageProduct.id !== meteredCredit.id,
    );
    setValue('usageProducts', updatedUsageProducts);
  };

  return (
    <IconButton className="h-6 w-6" onClick={handleRemoveRow}>
      <CloseIcon />
    </IconButton>
  );
};
